module.exports = __webpack_public_path__ + "static/img/construindo-site-aviao-sitejet.e8b353a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/construindo-site-aviao-sitejet.gif
// module id = 2081
// module chunks = 5